module.exports = __webpack_public_path__ + "media/LivingRoom.6fa25b9b.mp3";